import { render } from "./Spread.vue?vue&type=template&id=2fbdbf49&ts=true&lang=pug"
import script from "./Spread.vue?vue&type=script&setup=true&lang=ts"
export * from "./Spread.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__